import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const airplaneRightToLeftPath: PathObjectInterface = {
  mainPath: { x: 4000, y: 1500 },
  spline: [4000, 1500, -150, 700],
}
